import { render, staticRenderFns } from "./Salud.vue?vue&type=template&id=9288e95c&scoped=true&"
import script from "./Salud.vue?vue&type=script&lang=js&"
export * from "./Salud.vue?vue&type=script&lang=js&"
import style0 from "./Salud.vue?vue&type=style&index=0&id=9288e95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9288e95c",
  null
  
)

export default component.exports